import { Component } from '@angular/core';
import { ProcessParticipationApprovalRequirementType } from '../../models/process-models';
import { ConfirmationRespondentService } from '../../services/confirmation-respondent.service';

@Component({
  selector: 'app-my-bu',
  templateUrl: './my-bu.component.html',
  styleUrls: ['./my-bu.component.scss'],
})
export class MyBuComponent {
  requirementType: any = ProcessParticipationApprovalRequirementType;
  isSurveyTabActive: boolean;
  constructor(
    private readonly confirmationService: ConfirmationRespondentService
  ) {}

  emitSurveyTabValue(value: boolean) {
    this.isSurveyTabActive = value;
    this.confirmationService.myBuSurveyTabClick(value);
  }
}
